
export class ProgressStep {
  public id: number = 0;
  public name: string = 'Step';
  public iconClassString: string = '';
  public routerLink?: string | undefined;
}
